import React from 'react';
var HeaderOperateur = function (_a) {
    var children = _a.children, isVertical = _a.isVertical;
    var classNameOperateur = "fr-header__operator";
    if (isVertical) {
        classNameOperateur += " fr-header__operator_vertical";
    }
    return (React.createElement("div", { className: classNameOperateur }, children));
};
export default HeaderOperateur;
